import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { WorkspaceSelectors } from '@app/shared/store/selectors';
import { WorkspaceService } from '@keeps-platform-frontend-workspace/kp-keeps';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as fromActions from '../store/workspace.actions';

@Component({
  selector: 'app-workspace-image-upload',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
  template: `
    <div class="flex gap-5 h-60">
      <kp-image-upload-v2
        class="aspect-[1]"
        [matTooltip]="'WORKSPACES.LOGO_LABEL' | transloco"
        [imageSrc]="logo$ | async"
        [aspectRatio]="1"
        [resizeToWidth]="200"
        [resizeToHeight]="200"
        (uploadImage)="uploadLogo($event)"
      ></kp-image-upload-v2>

      <kp-image-upload-v2
        class="aspect-[1]"
        [matTooltip]="'WORKSPACES.ICON_LABEL' | transloco"
        [imageSrc]="icon$ | async"
        [aspectRatio]="1"
        [resizeToWidth]="200"
        [resizeToHeight]="200"
        (uploadImage)="uploadIcon($event)"
      ></kp-image-upload-v2>
    </div>
  `,
})
export class WorkspaceImageUploadComponent {
  logo$: Observable<string>;
  icon$: Observable<string>;

  private _id: string;

  constructor(
    private store: Store,
    private workspaceService: WorkspaceService,
  ) {
    this._id = this.workspaceService.getCurrentWorkspace().id;
    this.logo$ = this.store.select(WorkspaceSelectors.selectLogo(this._id));
    this.icon$ = this.store.select(WorkspaceSelectors.selectIcon(this._id));
  }

  uploadLogo(file: File) {
    this.upload(file, 'logo');
  }

  uploadIcon(file: File) {
    this.upload(file, 'icon');
  }

  private upload(file: File, type: 'icon' | 'logo') {
    this.store.dispatch(fromActions.uploadImage({ payload: { workspaceId: this._id, file, type } }));
  }
}
